/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import React from 'react';
import { Link } from 'react-router-dom';

export const renderOutcome = ({
  title,
  message = '',
  link = undefined,
  linkText = '',
  reload = false,
}) => {
  return <div className='genericOnboarding row'>
    <div className='offset-3 col-6'>
      <h1>{title}</h1>
      <p dangerouslySetInnerHTML={{ __html: message }}/>
      {link &&
      <Link to={link}
            onClick={(e) => {
              if (reload) {
                e.preventDefault();
                window.location.href = link
              }
            }}
            className='mt-4 btn btn-primary w-100'>
        {linkText}
      </Link>
      }
    </div>
  </div>
};
